module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/captchaImg.c2720d0b.png";